import bar_apexchart from './bar/apexchart/bar/parameters';
import line_apexchart from './bar/apexchart/line/parameters';
import scatter_apexchart from './bar/apexchart/scatter/parameters';
import area_apexchart from './bar/apexchart/area/parameters';
import heatmap_apexchart from './bar/apexchart/heatmap/parameters';
import pie_apexchart from './bar/apexchart/pie/parameters';
import { hydrator as bar_apexchart_hydrator } from "@/components/charts/bar/apexchart/hydrator.js";
import { hydrator as pie_apexchart_hydrator } from "@/components/charts/bar/apexchart/pie/hydrator.js";

import radial_apexchart from './bar/apexchart/radial/parameters';
import { hydrator as radial_apexchart_hydrator } from "@/components/charts/bar/apexchart/radial/hydrator.js";

import blank_parameters from '@/components/charts/blank/parameters';
import {
  hydrator as blank_hydrator
} from "@/components/charts/blank/hydrator";

import echartneonpie_parameters from '@/components/charts/pie/echart-neon-pie/parameters';
import echartneonpie_hydrator from "@/components/charts/pie/echart-neon-pie/hydrator";

//import echartcalendarmultiple_parameters from '@/components/charts/calendar/multiple/parameters';
//import echartcalendarmultiple_hydrator from "@/components/charts/calendar/multiple/hydrator";

import echartmotion_parameters from '@/components/charts/echart/motion/parameters';
import echartmotion_hydrator from "@/components/charts/echart/motion/hydrator";

import echartmap_parameters from '@/components/charts/echart/map/parameters';
import echartmap_hydrator from "@/components/charts/echart/map/hydrator";

import sparklinenumber_parameters from '@/components/charts/sparkline/number/parameters';
import sparklinenumber_hydrator from "@/components/charts/sparkline/number/hydrator";

import summary_parameters from '@/components/charts/sparkline/summary/parameters';
import summary_hydrator from "@/components/charts/sparkline/summary/hydrator";

import datefilter_parameters from '@/components/charts/filter/date/parameters';
import datefilter_hydrator from "@/components/charts/filter/date/hydrator";

import quilltext_parameters from '@/components/charts/text/quill/parameters';
import quilltext_hydrator from "@/components/charts/text/quill/hydrator";

import html_parameters from '@/components/charts/text/html/parameters';
import html_hydrator from "@/components/charts/text/html/hydrator";

import awb_form_parameters from '@/components/charts/form/awb/parameters';
import awb_form_hydrator from "@/components/charts/form/awb/hydrator";

import table_parameters from '@/components/charts/table/default/parameters';
import table_hydrator from "@/components/charts/table/default/hydrator";

import table2_parameters from '@/components/charts/table/table/parameters';
import table2_hydrator from "@/components/charts/table/table/hydrator";

import filter_toolbar_parameters from '@/components/charts/filter/toolbar/parameters';
import filter_toolbar_hydrator from "@/components/charts/filter/toolbar/hydrator";

import layout_parameters from '@/components/charts/layout/parameters';
import layout_hydrator from "@/components/charts/layout/hydrator";

import application_parameters from '@/components/charts/application/parameters';
import application_hydrator from "@/components/charts/application/hydrator";

import form_parameters from '@/components/charts/form/parameters';
import form_hydrator from "@/components/charts/form/hydrator";

import image_viewer_parameters from '@/components/charts/image/viewer/parameters';
import image_viewer_hydrator from "@/components/charts/image/viewer/hydrator";

import form_search_parameters from '@/components/charts/form/search/parameters';
import form_search_hydrator from "@/components/charts/form/search/hydrator";

import layout_tabs_parameters from '@/components/charts/tabs/layout-tabs/parameters';
import layout_tabs_hydrator from "@/components/charts/tabs/layout-tabs/hydrator";

import legalworkflow365_template_parameters from '@/components/charts/form/legalworkflow365/template/parameters';
import legalworkflow365_template_hydrator from "@/components/charts/form/legalworkflow365/template/hydrator";

import form_builder_parameters from '@/components/charts/form/builder/parameters';
import form_builder_hydrator from "@/components/charts/form/builder/hydrator";

import card_default_parameters from '@/components/charts/card/parameters';
import card_default_hydrator from "@/components/charts/card/hydrator";

import map_google_parameters from '@/components/charts/map/gmap/parameters';
import map_google_hydrator from "@/components/charts/map/gmap/hydrator";

import dms_parameters from '@/components/charts/dms/parameters';
import dms_hydrator from "@/components/charts/dms/hydrator";

import well_parameters from '@/components/charts/welldatabase/filter/parameters';
import well_hydrator from "@/components/charts/welldatabase/filter/hydrator";


const chartTypes = [
  {
    id: 'application',
    component: 'Taybull Application',
    title: 'Application',
    icon: '',
    parameters: application_parameters,
    hydrator: application_hydrator
  },
  {
    id: 'layout-element',
    component: 'vue-layout',
    title: 'Layout',
    icon: '',
    parameters: layout_parameters,
    hydrator: layout_hydrator
  },
  {
    id: 'line.apexchart',
    component: 'apexchart',
    title: 'Line',
    icon: '/chart-icons/line-chart-170x170.png',
    parameters: bar_apexchart,
    hydrator: bar_apexchart_hydrator
  },
  {
    id: 'area.apexchart',
    component: 'apexchart',
    title: 'Area',
    icon: '/chart-icons/area-chart-170x170.png',
    parameters: area_apexchart,
    hydrator: bar_apexchart_hydrator
  },
  //  {id: 'column.apexchart', component: 'apexchart', title: 'Column', parameters: bar_apexchart, hydrator: bar_apexchart_hydrator},
  {
    id: 'bar.apexchart',
    component: 'apexchart',
    title: 'Bar',
    icon: '/chart-icons/bar-chart-170x170.png',
    parameters: bar_apexchart,
    hydrator: bar_apexchart_hydrator
  },
  //  {id: 'mixed.apexchart', component: 'apexchart', title: 'Mixed', parameters: bar_apexchart, hydrator: bar_apexchart_hydrator},
  //{id: 'candlestick.apexchart', component: 'apexchart', title: 'Candlestick', parameters: bar_apexchart, hydrator: bar_apexchart_hydrator},
  //{id: 'bubble.apexchart', component: 'apexchart', title: 'Bubble', parameters: bar_apexchart, hydrator: bar_apexchart_hydrator},
  {
    id: 'scatter.apexchart',
    component: 'apexchart',
    title: 'Scatter',
    icon: '/scatter-icons/line-chart-170x170.png',
    parameters: scatter_apexchart,
    hydrator: bar_apexchart_hydrator
  },
  {
    id: 'heatmap.apexchart',
    component: 'apexchart',
    title: 'Heatmap',
    icon: '/chart-icons/heatmap-chart-170x170.png',
    parameters: heatmap_apexchart,
    hydrator: bar_apexchart_hydrator
  },
  {
    id: 'pie.apexchart',
    component: 'apexchart',
    title: 'Pie',
    icon: '/chart-icons/pie-chart-170x170.png',
    parameters: pie_apexchart,
    hydrator: pie_apexchart_hydrator
  },
  {
    id: 'radial.apexchart',
    component: 'apexchart',
    title: 'Circular',
    icon: '/chart-icons/pie-chart-170x170.png',
    parameters: radial_apexchart,
    hydrator: radial_apexchart_hydrator
  },
  {
    id: 'donut.apexchart',
    component: 'apexchart',
    title: 'Donut',
    icon: '/chart-icons/donut-chart-170x170.png',
    parameters: pie_apexchart,
    hydrator: pie_apexchart_hydrator
  },
  //{id: 'radial.apexchart', component: 'apexchart', title: 'Radial Bar', parameters: pie_apexchart, hydrator: pie_apexchart_hydrator},
  //{id: 'radar.apexchart', component: 'apexchart', title: 'Radar', parameters: bar_apexchart, hydrator: bar_apexchart_hydrator},
  { id: 'echarts.neon.pie', component: 'echarts', title: 'Pie - Neon', parameters: echartneonpie_parameters, hydrator: echartneonpie_hydrator },
  //{id: 'echarts.calendar.multiple', component: 'echarts', title: 'Calendar - Multiple', parameters: echartcalendarmultiple_parameters, hydrator: echartcalendarmultiple_hydrator},
  { id: 'echarts.motion', component: 'echarts', title: 'Motion', parameters: echartmotion_parameters, hydrator: echartmotion_hydrator },
  { id: 'echarts.map', component: 'echarts', title: 'Map', parameters: echartmap_parameters, hydrator: echartmap_hydrator },
  {
    id: 'sparkline.number',
    component: 'apexchart',
    title: 'Large Number',
    icon: '/chart-icons/large-number-chart-170x170.png',
    parameters: sparklinenumber_parameters,
    hydrator: sparklinenumber_hydrator
  },
  {
    id: 'sparkline.summary',
    component: 'apexchart',
    icon: '/chart-icons/summary-chart-170x170.png',
    title: 'Summary',
    parameters: summary_parameters,
    hydrator: summary_hydrator
  },
  {
    id: 'filter.date',
    component: 'apexchart',
    title: 'Date Filter',
    icon: '/chart-icons/date-filter-chart-170x170.png',
    parameters: datefilter_parameters,
    hydrator: datefilter_hydrator
  },
  {
    id: 'text.quill',
    component: 'apexchart',
    title: 'Content',
    icon: '/chart-icons/content-chart-170x170.png',
    parameters: quilltext_parameters,
    hydrator: quilltext_hydrator
  },
  {
    id: 'text.html',
    component: 'apexchart',
    title: 'HTML',
    icon: '/chart-icons/content-chart-170x170.png',
    parameters: html_parameters,
    hydrator: html_hydrator
  },
  {
    id: 'table',
    component: 'apexchart',
    title: 'Table Chart',
    icon: '/chart-icons/table-chart-170x170.png',
    parameters: bar_apexchart,
    hydrator: table_hydrator
  },
  {
    id: 'selectable-table',
    component: 'apexchart',
    title: 'Table',
    parameters: table2_parameters,
    hydrator: table2_hydrator
  },
  {
    id: 'filter.toolbar',
    component: 'toolbar',
    title: 'Toolbar',
    icon: '/chart-icons/toolbar-chart-170x170.png',
    parameters: filter_toolbar_parameters,
    hydrator: filter_toolbar_hydrator
  },
  {
    id: 'blank',
    component: 'blank',
    title: 'Blank',
    icon: '/chart-icons/blank-170x170.png',
    parameters: blank_parameters,
    hydrator: blank_hydrator
  },
  {
    id: 'form.default',
    component: 'form',
    title: 'Form',
    icon: '/chart-icons/blank-170x170.png',
    parameters: form_parameters,
    hydrator: form_hydrator
  },
  {
    id: 'form.awb',
    component: 'awbform',
    title: 'AWB Form',
    icon: '/chart-icons/blank-170x170.png',
    parameters: awb_form_parameters,
    hydrator: awb_form_hydrator
  },
  {
    id: 'image.viewer',
    component: 'image-viewer',
    title: 'Image Viewer',
    icon: '/chart-icons/blank-170x170.png',
    parameters: image_viewer_parameters,
    hydrator: image_viewer_hydrator
  },
  {
    id: 'form.search',
    component: 'form-viewer',
    title: 'Form Search',
    icon: '/chart-icons/blank-170x170.png',
    parameters: form_search_parameters,
    hydrator: form_search_hydrator
  },
  {
    id: 'layout.tabs',
    component: 'layout-tabs',
    title: 'Tabs (Layout)',
    icon: '/chart-icons/tabs.scene.png',
    parameters: layout_tabs_parameters,
    hydrator: layout_tabs_hydrator
  },
  {
    id: 'form.builder',
    component: 'form-builder',
    title: 'Form Builder',
    icon: '/chart-icons/tabs.scene.png',
    parameters: form_builder_parameters,
    hydrator: form_builder_hydrator
  },
  {
    id: 'card.default',
    component: 'card-default',
    title: 'Card',
    icon: '',
    parameters: card_default_parameters,
    hydrator: card_default_hydrator
  },
  {
    id: 'map.google',
    component: 'google-map-default',
    title: 'Google Map',
    icon: '',
    parameters: map_google_parameters,
    hydrator: map_google_hydrator
  },
  {
    id: 'dms',
    component: 'dms',
    title: 'Document Mgt',
    icon: '',
    parameters: dms_parameters,
    hydrator: dms_hydrator
  },
  {
    id: 'legalworkflow365.template',
    component: 'legalworkflow365-template',
    title: 'LegalFlow Temp',
    icon: '',
    parameters: legalworkflow365_template_parameters,
    hydrator: legalworkflow365_template_hydrator
  },
  {
    id: 'wellfilter',
    component: 'wellfilter',
    title: 'Well FIlter',
    icon: '',
    parameters: well_parameters,
    hydrator: well_hydrator
  }
];


// Icons : https://github.com/Haonancx/chart-type-icon

export function loadParameter(id) {
  const chart = chartTypes.find(chart => chart.id === id);

  let parameters = chart ? JSON.parse(JSON.stringify(chart.parameters)) : {};


  if (!chart) {
    return parameters;
  }
  if (id == 'application') {
    return parameters;
  }


  parameters.chartCode = {
    label: 'Code',
    source: 'parameters.never',
    class: 'xs12 sm12 d-flex',
    type: 'input',
    display: true,
    wait: false
  };

  parameters.overlayContentStyle = {
    label: 'Style',
    source: 'parameters.never',
    groupId: 'layeredInfo',
    items: [],
    types: [],
    class: 'xs12 sm12 d-flex',
    type: 'textarea',
    value: 'position: fixed; font-size: 14px;  z-index: 20000; top: 25%; right: 12%; width: 320px; min-height: 150px; height: auto; background-color: rgba(0, 0, 0, 0.5); padding: 10px; color: #fff;',
    display: true,
    wait: false
  };


  parameters.overlayContent = {
    label: 'Content',
    source: 'parameters.never',
    groupId: 'layeredInfo',
    items: [],
    types: [],
    class: 'xs12 sm12 d-flex',
    type: 'textarea',
    value: '',
    display: true,
    wait: false
  };

  if (id == 'layout-element') {
    return parameters;
  }

  parameters.cacheable = {
    label: 'Cacheable',
    class: 'xs12 xs12',
    type: 'switch',
    value: false
  }

  //        aggregates: [
  //          {aggregate: 'sum(', text: 'Sum'},
  //          {aggregate: 'average(', text: 'Average'},
  //          {aggregate: 'min(', text: 'Minimum'},
  //          {aggregate: 'max(', text: 'Maximum'},
  //          {aggregate: 'count(', text: 'Count'},
  //          {aggregate: 'count(distinct ', text: 'Count Unique'}
  //        ],


  if (typeof parameters.transformValueData != "undefined") {
    parameters.transformValueData = {
      label: 'Aggregate',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.transformValueData.aggregates',
      itemText: 'text',
      aggregates: [{
        aggregate: 'field',
        text: 'None'
      },
      {
        aggregate: 'sum(num(field))',
        text: 'Sum',
        description: 'Total'
      },
      {
        aggregate: 'avg(num(field))',
        text: 'Average',
        description: 'Average'
      },
      {
        aggregate: 'min(num(field))',
        text: 'Minimum',
        description: 'Minimum'
      },
      {
        aggregate: 'max(num(field))',
        text: 'Maximum',
        description: 'Maximum'
      },
      {
        aggregate: 'count(field)',
        text: 'Count',
        description: 'Count'
      },
      {
        aggregate: 'count(distinct field)',
        text: 'Count Unique',
        description: 'Count Unique'
      }
      ],
      itemValue: 'aggregate',
      value: 'sum(num(field))',
      items: [],
      item: {},
      wait: false
    };
  }

  /**
    aggregates: [
      {format: "field", text: 'None'},
      {format: "strftime('%Y %m %d', field)", text: 'Daily'},
      {format: "strftime('Week %W %Y', field)", text: 'Weekly'},
      {format: "strftime('%Y %m', field)", text: 'Monthly'},
      {format: "strftime('%Y', field)", text: 'Yearly'}
    ],**/

  if (typeof parameters.transformItemData != "undefined") {
    parameters.transformItemData = {
      label: 'Format',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.transformItemData.aggregates',
      itemText: 'text',
      aggregates: [{
        format: "\"field\"",
        text: 'None',
        comparison: '',
        comparisonDescription: ''
      },
      {
        format: "dt(\"field\",'YYYY MM DD')",
        text: 'Daily',
        comparison: 'DoD',
        transformamationType: "date",
        comparisonDescription: 'Vs Previous Day',
        type: "date",
        formatString: "YYYY MM DD",
        up: "dt(\"field\",'YYYY WW')"
      },
      {
        format: "to_char(dt(\"field\",'YYYY MM DD')::date, 'day')",
        transformamationType: "date",
        text: 'Day',
        comparison: 'Day',
        comparisonDescription: 'Day'
      },
      {
        format: "weekgroup(dt(\"field\",'YYYY MM DD')::date)",
        transformamationType: "date",
        text: 'Week End/Day',
        comparison: 'WE WD',
        comparisonDescription: 'Week End/Week Day'
      },
      {
        format: "dt(\"field\",'YYYY WW')",
        text: 'Weekly',
        comparison: 'WoW',
        comparisonDescription: 'Week On Week',
        up: "dt(\"field\",'YYYY MM')",
        down: "dt(\"field\",'YYYY MM DD')"
      },
      {
        format: "dt(\"field\",'YYYY MM')",
        transformamationType: "date",
        text: 'Monthly',
        comparison: 'MoM',
        comparisonDescription: 'Month on Month',
        down: "dt(\"field\",'YYYY WW')",
        up: "dt(\"field\",'YYYY')"
      },
      {
        format: "dt(\"field\",'YYYY')",
        transformamationType: "date",
        text: 'Yearly',
        comparison: 'YoY',
        comparisonDescription: 'Year on Year',
        down: "dt(\"field\",'YYYY MM')"
      }
      ],
      itemValue: 'format',
      value: "field",
      items: [],
      item: {},
      wait: false
    };
  }

  parameters.aggregateList = {
    label: 'Format',
    class: 'xs12 sm6',
    type: 'list',
    source: 'parameters.transformItemData.aggregates',
    itemText: 'text',
    aggregates: [
      {
        function: 'field',
        functionDisplay: 'field',
        text: 'None'
      },
      {
        function: 'sum(num(\"field\"))',
        aggregateFunction: true,
        functionDisplay: 'Sum(field)',
        text: 'Sum',
        description: 'Total'
      },
      {
        function: 'avg(num(\"field\"))',
        aggregateFunction: true,
        functionDisplay: 'Avg(field)',
        text: 'Average',
        description: 'Average'
      },
      {
        function: 'min(num(\"field\"))',
        aggregateFunction: true,
        functionDisplay: 'Min(field)',
        text: 'Minimum',
        description: 'Minimum'
      },
      {
        function: 'max(num(\"field\"))',
        functionDisplay: 'Max(field)',
        text: 'Maximum',
        description: 'Maximum'
      },
      {
        function: 'count(\"field\")',
        aggregateFunction: true,
        functionDisplay: 'Count(field)',
        text: 'Count',
        description: 'Count'
      },
      {
        function: 'count(distinct \"field\")',
        aggregateFunction: true,
        functionDisplay: 'CountD(field)',
        text: 'Count Unique',
        description: 'Count Unique'
      },
      {
        function: "dt(\"field\",'YYYY MM DD')",
        functionDisplay: "Date(field)",
        text: 'Date',
        comparison: 'DoD',
        comparisonDescription: 'Vs Previous Day',
        type: "date",
        formatString: "YYYY MM DD",
        up: "dt(\"field\",'YYYY WW')"
      },
      {
        function: "to_char(dt(\"field\",'YYYY MM DD')::date, 'day')",
        functionDisplay: "Day(field)",
        text: 'Day',
        comparison: 'Day',
        comparisonDescription: 'Day'
      },
      {
        function: "weekgroup(dt(\"field\",'YYYY MM DD')::date)",
        functionDisplay: "WeekGroup(field)",
        text: 'Week End/Day',
        comparison: 'WE WD',
        comparisonDescription: 'Week End/Week Day'
      },
      {
        function: "dt(\"field\",'YYYY WW')",
        functionDisplay: "Week(field)",
        text: 'Week',
        comparison: 'WoW',
        comparisonDescription: 'Week On Week',
        up: "dt(\"field\",'YYYY MM')",
        down: "dt(\"field\",'YYYY MM DD')"
      },
      {
        function: "dt(\"field\",'YYYY MM')",
        functionDisplay: "Month('field')",
        text: 'Month',
        comparison: 'MoM',
        comparisonDescription: 'Month on Month',
        down: "dt(\"field\",'YYYY WW')",
        up: "dt(\"field\",'YYYY')"
      },
      {
        function: "dt(\"field\",'YYYY')",
        functionDisplay: "Year(field)",
        text: 'Year',
        comparison: 'YoY',
        comparisonDescription: 'Yeay on Year',
        down: "dt(\"field\",'YYYY MM')"
      }
    ],
    itemValue: 'format',
    value: "field",
    items: [],
    item: {},
    wait: false
  };

  // to_char('2016-12-18'::date, 'day')

  if (typeof parameters.legendPositionData != "undefined") {
    parameters.legendPositionData = {
      label: 'Format',
      class: 'xs12 sm6',
      type: 'select',
      source: 'parameters.legendPositionData.aggregates',
      itemText: 'text',
      aggregates: [{
        position: "top",
        text: 'Top'
      },
      {
        position: "right",
        text: 'Right'
      },
      {
        position: "bottom",
        text: 'Bottom'
      },
      {
        position: "left",
        text: 'Left'
      }
      ],
      itemValue: 'position',
      value: "top",
      items: [],
      item: {},
      wait: false
    };
  }

  if (typeof parameters.expandToPage == "undefined") {
    parameters.expandToPage = {
      label: 'Expand To Page',
      class: 'xs12 sm12 d-flex',
      type: 'select',
      groupId: 'link',
      source: 'filteredCharts',
      itemValue: 'id',
      itemText: 'name',
      value: null,
      items: [],
      item: { id: null, name: null },
      wait: false
    };
  }



  if (typeof parameters.boxShadow == "undefined") {
    parameters.boxShadow = {
      label: 'Shadow',
      groupId: 'design',
      class: 'xs12',
      type: 'slider',
      source: 'parameters.never',
      value: 2,
      items: [],
      item: {}
    };
  }

  if (typeof parameters.customFilter == "undefined") {
    parameters.customFilter = {
      label: 'Custom Filter',
      source: 'parameters.never',
      groupId: 'filter',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: ' ',
      display: true,
      wait: false
    };
  }

  if (typeof parameters.parameterisedFilter == "undefined") {
    parameters.parameterisedFilter = {
      label: 'Parameterised Filter',
      source: 'parameters.never',
      groupId: 'filter',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: ' ',
      display: true,
      wait: false
    };
  }



  if (typeof parameters.style == "undefined") {
    parameters.style = {
      label: 'Style',
      source: 'parameters.never',
      groupId: 'design',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'textarea',
      value: ' ',
      display: true,
      wait: false
    };
  }

  if (typeof parameters.colors == "undefined") {
    parameters.colors = {
      label: 'Colors',
      source: 'parameters.never',
      items: [],
      types: [],
      groupId: 'design',
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
    };
  }

  if (typeof parameters.class == "undefined") {
    parameters.class = {
      label: 'Class',
      groupId: 'design',
      source: 'parameters.never',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
    };
  }

  if (typeof parameters.showLegendSource != "undefined") {
    parameters.showLegendSource = {
      label: 'Show legend',
      class: 'xs12 sm6',
      type: 'switch',
      groupId: 'design',
      source: 'parameters.formatSource.aggregates',
      itemValue: 'format',
      value: true,
      items: [],
      item: {
        data: [],
        headers: []
      }
    };
  }

  if (typeof parameters.refreshInterval == "undefined") {
    parameters.refreshInterval = {
      label: 'Refresh Interval (seconds)',
      source: 'parameters.never',
      items: [],
      types: [],
      groupId: 'sqlQuery',
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
    };
  }

  if (typeof parameters.refreshQuery == "undefined") {
    parameters.refreshQuery = {
      label: 'Refresh Query',
      source: 'parameters.never',
      groupId: 'sqlQuery',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
    };
  }

  if (typeof parameters.sqlQuery == "undefined") {
    parameters.sqlQuery = {
      label: 'Custom SQL Query (select * from x)',
      source: 'parameters.never',
      groupId: 'sqlQuery',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'code',
      value: '',
      display: true,
      wait: false
    };
  }




  if (typeof parameters.filterId == "undefined") {
    parameters.filterId = {
      label: 'Filter Id',
      source: 'parameters.never',
      groupId: 'filter',
      items: [],
      types: [],
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
    };
  }


  if (typeof parameters.orderBy == "undefined") {
    parameters.orderBy = {
      label: 'Order By',
      source: 'parameters.never',
      items: [],
      types: [],
      groupId: 'sqlQuery',
      class: 'xs12 sm12 d-flex',
      type: 'input',
      value: '',
      display: true,
      wait: false
    };
  }




  return parameters;

};

export function loadHydrator(id) {
  const chart = chartTypes.find(chart => chart.id === id);
  return chart ? chart.hydrator : function () { };
};



export {
  chartTypes
};
